import React, { useEffect } from 'react';
import { Snackbar, Button } from '@mui/material';
import { useRecoilState } from 'recoil';
import { signOut } from './firebase';
import * as serviceWorker from './serviceWorkerRegistration';
import { _ServiceWorkerUpdate } from './_Recoil/atoms';

const ServiceWorkerWrapper = () => {
  const [showReload, setShowReload] = useRecoilState(_ServiceWorkerUpdate);
  const [waitingWorker, setWaitingWorker] = React.useState(null);

  const onSWUpdate = (registration) => {
    console.log('sw change');
    setShowReload(true);
    setWaitingWorker(registration.waiting);
    registration.waiting?.postMessage({ type: 'SKIP_WAITING' });
  };
  const onSWSuccess = () => {
    // console.log('sw success', registration);
    // waitingWorker?.postMessage({ type: 'SKIP_WAITING' });
    // setWaitingWorker(registration.waiting);
  };

  useEffect(() => {
    // const interval = setInterval(() => {
    //   serviceWorker.checkForUpdate();
    // }, 1000);
  }, []);
  useEffect(() => {
    serviceWorker.register({ onUpdate: onSWUpdate, onSuccess: onSWSuccess });
  }, []);

  const reloadPage = async () => {
    signOut().then(() => {
      localStorage.removeItem('ChangelogShown');
      waitingWorker?.postMessage({ type: 'SKIP_WAITING' });
      setShowReload(false);
      window.location.reload(true);
    });
  };

  return (
    <Snackbar
      open={showReload}
      message='A new version is available!'
      onClick={reloadPage}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      action={
        <Button color='inherit' size='small' onClick={reloadPage}>
          Reload
        </Button>
      }
    />
  );
};

export default ServiceWorkerWrapper;
